import { render, staticRenderFns } from "./EntityUndeleteConfirmDialog.vue?vue&type=template&id=a84cc238&scoped=true&"
import script from "./EntityUndeleteConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./EntityUndeleteConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./EntityUndeleteConfirmDialog.vue?vue&type=style&index=0&id=a84cc238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84cc238",
  null
  
)

export default component.exports